
import { ThunkAction } from 'redux-thunk';
import { Action } from 'redux';
import { actions } from '../actions';
import { getAmbassadorErrors, getControlId, getChallengeRequestPayload, getAfterSocialShareUrl, getAmbasssadorProfileRequestPayload, getApiPollingTimeInterval } from '../selectors';
import { actions as ambassadorActions } from 'ambassador';
import { AmbassadorDataApi, ChallengeDataApi, AfterSocialShareApi, AmbassadorProfileApi } from '../requests';
import { network } from '@imodules/helix';

export const initiateAmbassadorDataPolling = (): ThunkAction<void, RootState, unknown, Action<string>> => {
    return async (dispatch, getState) => {
        const state = getState();
        const timeInterval: number = getApiPollingTimeInterval(state) || 0;

        while (getAmbassadorErrors(state) < 5) {
            const request = dispatch(pollAmbassador());
            try {
                await request;
            } catch (error: any) {
                dispatch(actions.apiCallFailure(error.message));
            }
            await new Promise(resolve => setTimeout(resolve, timeInterval));
        }
    };
};

export const pollAmbassador = (): ThunkAction<void, RootState, unknown, Action<string>> => {
    return async (dispatch, getState) => {
        const state = getState();
        const controlId = getControlId(state);
        try {
            dispatch(await makeAmbassadorRequest(controlId));
            dispatch(actions.apiCallSuccess());
        } catch (error: any) {
            dispatch(actions.apiCallFailure(error.message));
        }
    };
};

export const makeAmbassadorRequest = (controlId: number): ThunkAction<void, RootState, unknown, Action<string>> => {
    return async (dispatch) => {
        try {
            const request = AmbassadorDataApi.createGetRequest(controlId);
            const result: any = await network.call(request);

            if (result.error) {
                dispatch(actions.apiCallFailure(result.error.message));
            } else {
                dispatch(ambassadorActions.populateAmbassadorData(result.response.content));
                dispatch(actions.apiCallSuccess());
            }
        } catch (error: any) {
            dispatch(actions.apiCallFailure(error.message));
        }
    };
};

export const initiateChallengeDataPolling = (): ThunkAction<void, RootState, unknown, Action<string>> => {
    return async (dispatch, getState) => {
        const state = getState();
        const timeInterval: number = getApiPollingTimeInterval(state) || 0;

        while (getAmbassadorErrors(state) < 5) {
            const request = dispatch(pollChallenge());
            try {
                await request;
            } catch (error: any) {
                dispatch(actions.apiCallFailure(error.message));
            }
            await new Promise(resolve => setTimeout(resolve, timeInterval));
        }
    };
};

export const pollChallenge = (): ThunkAction<void, RootState, unknown, Action<string>> => {
    return async (dispatch, getState) => {
        const state = getState();
        const payload = getChallengeRequestPayload(state);
        try {
            dispatch(await makeChallengeRequest(payload));
            dispatch(actions.apiCallSuccess());
        } catch (error: any) {
            dispatch(actions.apiCallFailure(error.message));
        }
    };
};

export const makeChallengeRequest = (payload: ChallengeRequestPayload): ThunkAction<void, RootState, unknown, Action<string>> => {
    return async (dispatch) => {
        try {
            const request = ChallengeDataApi.createGetRequest(payload.initiativeId, payload.parentFormId, payload.pageIndex);
            const result: any = await network.call(request);

            if (result.error) {
                dispatch(actions.apiCallFailure(result.error.message));
            } else {
                dispatch(ambassadorActions.populateAmbassadorChallenge(result.response.content));
                dispatch(actions.apiCallSuccess());
            }
        } catch (error: any) {
            dispatch(actions.apiCallFailure(error.message));
        }
    };
};

export const initiateAmbassadorProfilePolling = (): ThunkAction<void, RootState, unknown, Action<string>> => {
    return async (dispatch, getState) => {
        const state = getState();
        const timeInterval: number = getApiPollingTimeInterval(state) || 0;

        while (getAmbassadorErrors(state) < 5) {
            const request = dispatch(pollAmbassadorProfile());
            try {
                await request;
            } catch (error: any) {
                dispatch(actions.apiCallFailure(error.message));
            }
            await new Promise(resolve => setTimeout(resolve, timeInterval));
        }
    };
};

export const pollAmbassadorProfile = (): ThunkAction<void, RootState, unknown, Action<string>> => {
    return async (dispatch, getState) => {
        const state = getState();
        const payload = getAmbasssadorProfileRequestPayload(state);

        try {
            await dispatch(makeAmbassadorProfileRequest(payload));
            dispatch(actions.apiCallSuccess());
        } catch (error: any) {
            dispatch(actions.apiCallFailure(error.message));
        }
    };
};

export const makeAmbassadorProfileRequest = (payload: AmbassadorProfileRequestPayload): ThunkAction<void, RootState, unknown, Action<string>> => {
    return async (dispatch) => {
        try {
            const request = AmbassadorProfileApi.createGetRequest(payload.CreatedBy.AmbssadorId);
            const result: any = await network.call(request);

            if (result.error) {
                dispatch(actions.apiCallFailure(result.error.message));
            } else {
                dispatch(ambassadorActions.populateAmbassadorProfile(result.response.content[0]));
                dispatch(actions.apiCallSuccess());
            }
        } catch (error: any) {
            dispatch(actions.apiCallFailure(error.message));
        }
    };
};

export const initiateAfterSocialSharePolling = (): ThunkAction<void, RootState, unknown, Action<string>> => {
    return async (dispatch, getState) => {
        const state = getState();
        const timeInterval: number = getApiPollingTimeInterval(state) || 0;

        while (getAmbassadorErrors(state) < 5) {
            const request = dispatch(pollAfterSocialShareRequest());
            try {
                await request;
            } catch (error: any) {
                dispatch(actions.apiCallFailure(error.message));
            }
            await new Promise(resolve => setTimeout(resolve, timeInterval));
        }
    };
};

export const pollAfterSocialShareRequest = (): ThunkAction<void, RootState, unknown, Action<string>> => {
    return async (dispatch, getState) => {
        const state = getState();
        const postUrl = getAfterSocialShareUrl(state);
        try {
            dispatch(await makeAfterSocialShareRequest(postUrl));
            dispatch(actions.apiCallSuccess());
        } catch (error: any) {
            dispatch(actions.apiCallFailure(error.message));
        }
    };
};

export const makeAfterSocialShareRequest = (postUrl: string): ThunkAction<void, RootState, unknown, Action<string>> => {
    return async (dispatch) => {
        try {
            const request = AfterSocialShareApi.createPostRequest(postUrl);
            const result: any = await network.call(request);

            if (result && result.error) {
                dispatch(actions.apiCallFailure(result.error.message));
            } else {
                dispatch(actions.apiCallSuccess());
            }
        } catch (error: any) {
            dispatch(actions.apiCallFailure(error.message));
        }
    };
};


export const watchGetAmbassadorData = (): ThunkAction<void, RootState, unknown, Action<string>> => {
    return (dispatch) => {
        dispatch(initiateAmbassadorDataPolling);
    };
};

export const watchGetChallengeData = (): ThunkAction<void, RootState, unknown, Action<string>> => {
    return (dispatch) => {
        dispatch(initiateChallengeDataPolling);
    };

}

export const watchGetAmbassadorProfile = (): ThunkAction<void, RootState, unknown, Action<string>> => {
    return (dispatch) => {
        dispatch(initiateAmbassadorProfilePolling);
    };
}

export const watchAfterSocialShareRequest = (): ThunkAction<void, RootState, unknown, Action<string>> => {
    return (dispatch) => {
        dispatch(initiateAfterSocialSharePolling);
    };
}
